import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "MainPageBackground" }
const _hoisted_2 = { class: "TopBar" }
const _hoisted_3 = { class: "TopBarContent" }
const _hoisted_4 = { class: "Logo" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "home-particles" }
const _hoisted_7 = {
  id: "section-1",
  class: "full-page-section content-section"
}
const _hoisted_8 = { class: "decorative-sidebar" }
const _hoisted_9 = { class: "product-left" }
const _hoisted_10 = { class: "product-image-wrapper" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "product-right" }
const _hoisted_13 = { class: "game-title" }
const _hoisted_14 = { class: "game-subtitle" }
const _hoisted_15 = { class: "game-desc" }
const _hoisted_16 = { class: "highlight" }
const _hoisted_17 = { class: "game-list-sidebar" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 0,
  class: "info-boxes-wrapper"
}
const _hoisted_21 = {
  key: 1,
  class: "info-boxes-wrapper empty-announcement"
}
const _hoisted_22 = { class: "about-panel-container" }
const _hoisted_23 = { class: "about-navigation" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "card-num" }
const _hoisted_26 = { class: "card-title-group" }
const _hoisted_27 = { class: "card-title" }
const _hoisted_28 = { class: "card-subtitle" }
const _hoisted_29 = { class: "about-details-content" }
const _hoisted_30 = { class: "viewport-main-title" }
const _hoisted_31 = { class: "row-header" }
const _hoisted_32 = { class: "row-title" }
const _hoisted_33 = { class: "row-description" }
const _hoisted_34 = {
  key: 0,
  class: "all-list-overlay"
}
const _hoisted_35 = { class: "all-list-box" }
const _hoisted_36 = { class: "all-list-scroll" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "simple-info" }

import { ref, watch, onMounted, onUnmounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router"; // 引入路由 API
import useGlobalStateStore, { Enum_Theme } from "@/Store/GlobalStateStore";
import InfoBox_Left from "@/components/InfoBox_Left.vue";
import AnnouncementModal from "@/components/AnnouncementModal.vue";
import { AnOutlinedBilibili, AnOutlinedX, MdEmail, SiSinaweibo, CoBrandYoutube, AnOutlinedClose } from "@kalimahapps/vue-icons";
import { fetchAnnouncements } from "@/server/api";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainPage_CHT',
  setup(__props) {

_useCssVars(_ctx => ({
  "v656e4012": (ThemeTopBarBackgroundColor.value),
  "v4ae7f422": (activeSection.value === 0 ? "none" : "0 2px 4px rgba(0, 0, 0, 0.15)"),
  "v4b4f70e0": (ThemeTopBarColor.value),
  "v59c127aa": (ThemeItemColor.value),
  "v9f8fdd92": (ThemeHintColor.value),
  "ba694b56": (ThemeMainSloganCruxColor.value),
  "v54c1f487": (ThemeMainSloganColor.value),
  "v3cddec59": (ThemeSubSlogan.value),
  "v666f97f3": (ThemeIconBackgroundHoverColor.value),
  "v623fa035": (ThemeBottomBG.value),
  "a21664da": (ThemeBottomPartingLine.value),
  "bbf4748a": (ThemeCopyrightFiling.value)
}))

const GlobalStyleStore = useGlobalStateStore();
const activeSection = ref(0);
const scrollContainer = ref<HTMLElement | null>(null);

const route = useRoute();
const router = useRouter();

const isModalVisible = ref(false);
const currentAnnouncementData = ref<any>(null);

function openAnnouncementModal(item: any) {
  currentAnnouncementData.value = item;
  isModalVisible.value = true;

  // 將新聞 ID 同步到瀏覽器網址列
  router.replace({ query: { ...route.query, news_id: item.id } });
}

function closeAnnouncementModal() {
  isModalVisible.value = false;

  // 清除網址列中的 news_id 參數
  const currentQuery = { ...route.query };
  delete currentQuery.news_id;
  router.replace({ query: currentQuery });
}

const ThemeTopBarBackgroundColor = ref("transparent");
const ThemeTopBarColor = ref("#fff");
const ThemeItemColor = ref("#57E1D9");
const ThemeMainSloganColor = ref("#FFF");
const ThemeMainSloganCruxColor = ref("#57E1D9");
const ThemeSubSlogan = ref("#FFF");
const ThemeIconBackgroundColor = ref("#3fb7b0");
const ThemeIconBackgroundHoverColor = ref("#57E1D9");
const ThemeBottomBG = ref("#242424");
const ThemeBottomPartingLine = ref("#FFFFFF26");
const ThemeCopyrightFiling = ref("#FFF");
const ThemeHintColor = ref("#FFF");

// --- 首頁 3D 視差追蹤邏輯 ---
const mouseX = ref(0);
const mouseY = ref(0);
const isHoveringHome = ref(false);

function onHomeMouseMove(e: MouseEvent) {
  isHoveringHome.value = true;
  const { innerWidth, innerHeight } = window;
  mouseX.value = (e.clientX / innerWidth - 0.5) * 2;
  mouseY.value = (e.clientY / innerHeight - 0.5) * 2;
}

function onHomeMouseLeave() {
  isHoveringHome.value = false;
  mouseX.value = 0;
  mouseY.value = 0;
}

const homeBgLayers = computed(() => {
  const moveX = mouseX.value;
  const moveY = mouseY.value;

  const config = [
    { mult: 0.4, scale: 1.02, opacity: 0.35, blur: '6px', blend: 'normal', hue: 0 },
    { mult: 0.8, scale: 1.06, opacity: 0.50, blur: '3px', blend: 'normal', hue: 15 },
    { mult: 1.3, scale: 1.10, opacity: 0.90, blur: '0px', blend: 'normal', hue: 0 },
    { mult: 2.0, scale: 1.16, opacity: 0.40, blur: '2px', blend: 'screen', hue: -15 },
    { mult: 2.8, scale: 1.25, opacity: 0.25, blur: '10px', blend: 'color-dodge', hue: 30 }
  ];

  return config.map((layer, index) => {
    const x = moveX * layer.mult * 1.5;
    const y = moveY * layer.mult * 1.5;
    return {
      transform: `scale(${layer.scale}) translate(${-x}%, ${-y}%)`,
      transition: isHoveringHome.value ? 'transform 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'transform 2.5s ease-out',
      backgroundImage: "url('/Images/HomeBG.jpg')",
      opacity: layer.opacity,
      filter: `blur(${layer.blur}) hue-rotate(${layer.hue}deg)`,
      mixBlendMode: layer.blend as any,
      zIndex: index + 1
    };
  });
});

// --- 第四頁「了解我們」數據與面板內容 (繁體中文版) ---
const activeAboutTab = ref(0);
const aboutTabsData = [
  {
    num: "01",
    title: "總則",
    subTitle: "GENERAL",
    paragraphs: [
      { label: "企業簡介", desc: "遊晰概念LESJEUXA成立於2021年，作為一家新世代的遊戲創意公司，秉持「技術研發、藝術創造、新文化傳播」，致力於為亞洲乃至世界提供卓越且創新的「遊晰方案」。" },
      { label: "宗旨與使命", desc: "宗旨：我們以前沿科技為支撐，通過藝術創意激發文化活力，推動遊戲產業與文化交流的跨界融合。\n使命：我們以技術創新驅動產品開發，通過藝術表達傳遞人類理念，借助新媒體與多元平台傳播具有全球影響力的新文化。" },
      { label: "願景", desc: "不斷成為每個新時代中引領全球遊戲創意與文化傳播的先鋒企業，實現科技與藝術的完美交融，構建開放、共享、共創的數位生態，並為人類實現真正元宇宙與數位生命的夢想。" }
    ]
  },
  {
    num: "02",
    title: "綱領",
    subTitle: "CREED",
    paragraphs: [
      { label: "技術研發", desc: "我們堅持以科技為先導，不斷探索新技術與新方法，在人工智慧、區塊鏈、虛擬實境等領域取得突破，推動遊戲與元宇宙的革新。我們注重研發成果的商業化和實際應用，為全球用戶提供安全、流暢、創新的「遊晰概念」。" },
      { label: "藝術創造", desc: "我們尊重藝術多元化，激發創意潛能，鼓勵跨界合作，實現傳統文化與現代藝術、遊戲設計的融合。我們秉持原創精神，打造獨具風格的遊戲世界和視覺表達，傳遞獨特的審美體驗。" },
      { label: "新文化傳播", desc: "我們以開放包容的態度推動文化交流，通過多平台、多形式傳播符合時代精神的新文化理念。我們借助數位媒體和社群網路，讓全球用戶共享優質文化內容與創新體驗。" }
    ]
  },
  {
    num: "03",
    title: "實施與管理",
    subTitle: "ACTION",
    paragraphs: [
      { label: "創新驅動", desc: "我們建立跨學科、跨領域的創新團隊，鼓勵技術與藝術的深度融合，打造符合 future 趨勢的遊戲產品與文化項目。我們熱衷於各種形式的創意交流和行業研討活動，激發全員的創造力和團隊協作精神。" },
      { label: "制度保障", desc: "我們的專案管理依照以人類歷史最為透明的普通法系編寫的規則執行。我們制定完善的研發、創作與傳播標準，確保各環節高效、規範地開展工作。我們建立激勵與回饋機制，鼓勵成員勇於創新、不斷超越，形成良性循環的企業文化。" },
      { label: "市場與合作", desc: "我們積極拓展和研究國內外市場，構建戰略合作夥伴關係，攜手優秀企業與機構進入遊戲業2.0。我們注重品牌塑造，通過不斷創新和優質服務打造遊晰概念在全球遊戲文化與元宇宙領域的領先形象。" }
    ]
  }
];

watch(() => [GlobalStyleStore.CurrentTheme, activeSection.value], () => {
  const isDark = GlobalStyleStore.CurrentTheme === Enum_Theme.Dark;
  const isHome = activeSection.value === 0;

  ThemeTopBarBackgroundColor.value = isHome ? 'transparent' : (isDark ? 'rgba(28, 28, 28, 0.57)' : 'rgba(255, 255, 255, 0.57)');
  ThemeTopBarColor.value = isDark ? '#fff' : '#484848';
  ThemeItemColor.value = isDark ? '#57E1D9' : '#f77373';

  if (isDark) {
    ThemeMainSloganColor.value = '#FFF';
    ThemeMainSloganCruxColor.value = '#57E1D9';
    ThemeSubSlogan.value = '#FFF';
    ThemeIconBackgroundColor.value = '#3fb7b0';
    ThemeIconBackgroundHoverColor.value = '#57E1D9';
    ThemeBottomBG.value = '#242424';
    ThemeBottomPartingLine.value = '#FFFFFF26';
    ThemeCopyrightFiling.value = 'rgba(255,255,255,0.6)';
    ThemeHintColor.value = 'rgba(255,255,255,0.6)';
  } else {
    ThemeMainSloganColor.value = '#545454';
    ThemeMainSloganCruxColor.value = '#f77373';
    ThemeSubSlogan.value = '#1a1a1a';
    ThemeIconBackgroundColor.value = '#de5959';
    ThemeIconBackgroundHoverColor.value = '#f77373';
    ThemeBottomBG.value = '#efefef';
    ThemeBottomPartingLine.value = 'rgba(185,185,185,0.1)';
    ThemeCopyrightFiling.value = 'rgba(0,0,0,0.6)';
    ThemeHintColor.value = 'rgba(0,0,0,0.6)';
  }
}, { immediate: true });

function scrollToSection(index: number) {
  if (scrollContainer.value) {
    const section = scrollContainer.value.querySelector(`#section-${index}`);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  }
}

let observer: IntersectionObserver | null = null;
const allAnnouncements = ref<any[]>([]);
const topAnnouncements = ref<any[]>([]);

onMounted(async () => {
  const options = { root: scrollContainer.value, rootMargin: '0px', threshold: 0.5 };
  observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const idParts = entry.target.id.split('-');
        if (idParts.length === 2) {
          activeSection.value = parseInt(idParts[1]);
        }
      }
    });
  }, options);
  document.querySelectorAll('.full-page-section').forEach(sec => observer?.observe(sec));

  const rawData = await fetchAnnouncements();
  const chtList: any[] = [];

  rawData.forEach((item: any) => {
    try {
      // NOTE: 繁體中文數據過濾 (.cht 提取)
      const titles = item.title.startsWith('{') ? JSON.parse(item.title) : { cht: item.title };
      const summaries = item.summary.startsWith('{') ? JSON.parse(item.summary) : { cht: item.summary };
      const contents = item.content.startsWith('{') ? JSON.parse(item.content) : { cht: item.content };
      const authors = item.author && item.author.startsWith('{') ? JSON.parse(item.author) : { cht: item.author || '' };

      if(titles.cht) {
        chtList.push({
          ...item,
          title: titles.cht,
          summary: summaries.cht || '',
          author: authors.cht || '',
          content: contents.cht || ''
        });
      }
    } catch(error) {
      console.warn("JSON解析失敗, 可能是髒數據", error);
    }
  });

  allAnnouncements.value = chtList;
  topAnnouncements.value = chtList.slice(0, 3);

  // 頁面加載完畢後，檢測 URL 中是否帶有 news_id 參數
  const newsId = route.query.news_id;
  if (newsId) {
    const targetNews = allAnnouncements.value.find(item => String(item.id) === String(newsId));
    if (targetNews) {
      // 延遲確保 DOM 掛載完成，然後自動滾動並彈窗
      setTimeout(() => {
        activeSection.value = 2; // 強行激活「新聞動態」導航高亮
        scrollToSection(2);      // 滾動到新聞區塊
        openAnnouncementModal(targetNews);
      }, 500);
    }
  }
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
});

const isAllListModalVisible = ref(false);

const gameList = ref([
  {
    id: 1, titleCHS: '星夢旅記・域灰之夢', titleEN: 'Star Reverie·Greystasis',
    desc: [
      '灰域蔓延，異夢症肆虐，人類的棲身之所正加速崩塌。',
      '主角在一次偶然的契機中，加入了「紐克托福斯」，成為一名執約者。在與夥伴挽救危局、幫助他人、追尋身世的同時，主角悄然接近著世界的真相。',
      '然而，當象徵希望的「夢之源」亦被猩紅染指，當噩夢如潮水般吞沒現實，時間已所剩無幾，承載命運與夢境的容器瀕臨破碎，神之血終將傾瀉塵世——'
    ],
    highlight: '重啟，亦或終焉。',
    kvPath: '/Images/Games/Star Reverie/StarReverieKV.png',
    iconPath: '/Images/Games/Star Reverie/StarReverieIcon.png'
  }
]);
const currentGameIndex = ref(0);

function OnUserClickLogo() {
  if (GlobalStyleStore.CurrentTheme === Enum_Theme.Dark) {
    GlobalStyleStore.SetCurrentTheme(Enum_Theme.Light);
  } else {
    GlobalStyleStore.SetCurrentTheme(Enum_Theme.Dark);
  }
}

async function OnCLickEmail() {
  try {
    await navigator.clipboard.writeText("info@lesjeuxa.com");
    alert("已將郵件地址複製到剪貼簿，快來聯絡我們吧(๑′ᴗ‵๑)❤");
  } catch (error) {
    console.error("複製失敗", error);
  }
}

function OnCLickX() {
  window.open("https://x.com", "_blank");
}

function OnCLickWeiBo() {
  window.open("https://weibo.com/", "_blank");
}

function OnCLickBilibili() {
  window.open("https://www.bilibili.com/", "_blank");
}

function OnCLickYoutuber() {
  window.open("https://www.youtube.com/@lesjeuxa", "_blank");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_unref(GlobalStyleStore).CurrentTheme===_unref(Enum_Theme).Dark)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: "/Images/Logo.png",
                alt: "Logo",
                onClick: OnUserClickLogo
              }))
            : _createCommentVNode("", true),
          (_unref(GlobalStyleStore).CurrentTheme===_unref(Enum_Theme).Light)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: "/Images/Logo_1.png",
                alt: "Logo",
                onClick: OnUserClickLogo
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["NavBar", { 'hide-on-home': activeSection.value === 0 }])
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['首頁', '產品資訊', '新聞動態', '了解我們', '加入我們'], (item, index) => {
            return _createElementVNode("span", {
              key: index,
              class: _normalizeClass(["nav-item", { active: activeSection.value === index }]),
              onClick: ($event: any) => (scrollToSection(index))
            }, _toDisplayString(item), 11, _hoisted_5)
          }), 64))
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["Login", { 'hide-on-home': activeSection.value === 0 }])
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("span", { class: "item" }, "註冊", -1),
          _createElementVNode("span", { class: "separator" }, "|", -1),
          _createElementVNode("span", { class: "item" }, "登入", -1)
        ]))], 2)
      ])
    ]),
    _createElementVNode("div", {
      class: "ScrollContainer",
      ref_key: "scrollContainer",
      ref: scrollContainer
    }, [
      _createElementVNode("section", {
        id: "section-0",
        class: "full-page-section home-section",
        onMousemove: onHomeMouseMove,
        onMouseleave: onHomeMouseLeave
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(homeBgLayers.value, (layerStyle, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: idx,
            class: "home-parallax-bg",
            style: _normalizeStyle(layerStyle)
          }, null, 4))
        }), 128)),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "home-vignette-overlay" }, null, -1)),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(60, (n) => {
            return _createElementVNode("div", {
              class: "particle",
              key: n
            })
          }), 64))
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "overlay",
          style: {"z-index":"10"}
        }, null, -1)),
        _createElementVNode("div", {
          class: "scroll-hint",
          style: {"z-index":"11","cursor":"pointer"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollToSection(1)))
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("p", null, "向下捲動查看更多", -1),
          _createElementVNode("div", { class: "arrow-down" }, null, -1)
        ]))])
      ], 32),
      _createElementVNode("section", _hoisted_7, [
        _createElementVNode("div", {
          class: _normalizeClass(["product-container", { 'is-active': activeSection.value === 1 }])
        }, [
          _createElementVNode("div", _hoisted_8, [
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "dot" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(gameList.value[currentGameIndex.value].titleEN.toUpperCase()) + " ", 1),
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "dot" }, null, -1)),
            _cache[10] || (_cache[10] = _createTextVNode(" LESJEUXA", -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(), _createElementBlock("img", {
                src: gameList.value[currentGameIndex.value].kvPath,
                class: "product-kv",
                key: currentGameIndex.value
              }, null, 8, _hoisted_11))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h1", _hoisted_13, _toDisplayString(gameList.value[currentGameIndex.value].titleCHS), 1),
            _createElementVNode("h3", _hoisted_14, _toDisplayString(gameList.value[currentGameIndex.value].titleEN), 1),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameList.value[currentGameIndex.value].desc, (paragraph, i) => {
                return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(paragraph), 1))
              }), 128)),
              _createElementVNode("p", _hoisted_16, _toDisplayString(gameList.value[currentGameIndex.value].highlight), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameList.value, (game, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: game.id,
                class: _normalizeClass(["game-list-item", { 'is-selected': currentGameIndex.value === index }]),
                onClick: ($event: any) => (currentGameIndex.value = index)
              }, [
                _createElementVNode("img", {
                  src: game.iconPath
                }, null, 8, _hoisted_19)
              ], 10, _hoisted_18))
            }), 128))
          ])
        ], 2)
      ]),
      _createElementVNode("section", {
        id: "section-2",
        class: _normalizeClass(["full-page-section content-section", { 'is-active': activeSection.value === 2 }])
      }, [
        (topAnnouncements.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topAnnouncements.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "anim-item",
                  style: _normalizeStyle({ 'transition-delay': `${index * 0.2}s` })
                }, [
                  _createVNode(InfoBox_Left, {
                    Title: item.title,
                    Summary: item.summary,
                    ImagePath: item.cover_image,
                    onOpenModal: ($event: any) => (openAnnouncementModal(item))
                  }, null, 8, ["Title", "Summary", "ImagePath", "onOpenModal"])
                ], 4))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[11] || (_cache[11] = [
              _createElementVNode("p", null, "暫無最新動態", -1)
            ]))])),
        (allAnnouncements.value.length > 3)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "more-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (isAllListModalVisible.value = true))
            }, [...(_cache[12] || (_cache[12] = [
              _createTextVNode(" More ", -1),
              _createElementVNode("span", null, "+", -1)
            ]))]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("section", {
        id: "section-3",
        class: _normalizeClass(["full-page-section content-section learn-us-section", { 'is-active': activeSection.value === 3 }])
      }, [
        _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"about-header-slogan\" data-v-77c59676><h1 class=\"brand-core-slogan\" data-v-77c59676><span class=\"highlight-cyan\" data-v-77c59676>技術</span>研發 • <span class=\"highlight-cyan\" data-v-77c59676>藝術</span>創造 • <span class=\"highlight-cyan\" data-v-77c59676>新文化</span>傳播 </h1><p class=\"brand-core-desc\" data-v-77c59676> LESJEUXA 始終致力於前沿科技與藝術美學的交融，為數位時代提供卓爾不群的「遊晰方案」 </p></div>", 1)),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(aboutTabsData, (tab, index) => {
              return _createElementVNode("div", {
                key: index,
                class: _normalizeClass(["about-nav-card", { 'is-active': activeAboutTab.value === index }]),
                onClick: ($event: any) => (activeAboutTab.value = index)
              }, [
                _createElementVNode("span", _hoisted_25, _toDisplayString(tab.num), 1),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("span", _hoisted_27, _toDisplayString(tab.title), 1),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(tab.subTitle), 1)
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "card-glow-bar" }, null, -1))
              ], 10, _hoisted_24)
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_29, [
            (_openBlock(), _createElementBlock("div", {
              class: "details-viewport",
              key: activeAboutTab.value
            }, [
              _createElementVNode("h2", _hoisted_30, _toDisplayString(aboutTabsData[activeAboutTab.value].title) + "綱要", 1),
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "viewport-divider" }, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aboutTabsData[activeAboutTab.value].paragraphs, (para, pIdx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: pIdx,
                  class: "content-row",
                  style: _normalizeStyle({ 'animation-delay': `${pIdx * 0.15}s` })
                }, [
                  _createElementVNode("div", _hoisted_31, [
                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "row-indicator" }, null, -1)),
                    _createElementVNode("h4", _hoisted_32, _toDisplayString(para.label), 1)
                  ]),
                  _createElementVNode("p", _hoisted_33, _toDisplayString(para.desc), 1)
                ], 4))
              }), 128))
            ]))
          ])
        ])
      ], 2),
      _createElementVNode("section", {
        id: "section-4",
        class: "full-page-section end-section"
      }, [
        _createElementVNode("div", { class: "join-content" }, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "join-text-group" }, [
            _createElementVNode("h2", { class: "join-title" }, [
              _createTextVNode("加入我們 / "),
              _createElementVNode("span", { class: "highlight-text" }, "JOIN US")
            ]),
            _createElementVNode("p", { class: "join-subtitle" }, "期待您的才華，與我們共同編織下一個夢境。")
          ], -1)),
          _createElementVNode("div", {
            class: "contact-wrapper",
            onClick: OnCLickEmail
          }, [...(_cache[17] || (_cache[17] = [
            _createElementVNode("div", { class: "contact-label" }, "MAIL TO US", -1),
            _createElementVNode("div", { class: "contact-email" }, "info@lesjeuxa.com", -1),
            _createElementVNode("div", { class: "contact-hover-line" }, null, -1),
            _createElementVNode("div", { class: "contact-hint" }, "CLICK TO COPY / 點擊複製信箱地址", -1)
          ]))])
        ]),
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "BottomBG" }, [
          _createElementVNode("div", { class: "BottomPartingLine" }),
          _createElementVNode("div", { class: "BottomContent" }, [
            _createElementVNode("div", { class: "CopyrightFiling" }, "Copyright 2021-2026 LESJEUXA.COM 遊晰概念有限公司")
          ])
        ], -1))
      ])
    ], 512),
    _createVNode(AnnouncementModal, {
      visible: isModalVisible.value,
      announcement: currentAnnouncementData.value,
      onClose: closeAnnouncementModal
    }, null, 8, ["visible", "announcement"]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (isAllListModalVisible.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("button", {
                  class: "close-btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (isAllListModalVisible.value = false))
                }, [
                  _createVNode(_unref(AnOutlinedClose))
                ]),
                _cache[20] || (_cache[20] = _createElementVNode("h2", { style: {"color":"black","margin-bottom":"30px"} }, "全部動態", -1)),
                _createElementVNode("div", _hoisted_36, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allAnnouncements.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "simple-list-item",
                      key: item.id,
                      onClick: ($event: any) => (openAnnouncementModal(item))
                    }, [
                      _createElementVNode("img", {
                        src: item.cover_image,
                        class: "slim-cover"
                      }, null, 8, _hoisted_38),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("h3", null, _toDisplayString(item.title), 1),
                        _createElementVNode("p", null, _toDisplayString(item.summary), 1)
                      ])
                    ], 8, _hoisted_37))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", {
      class: "global-scroll-hint",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (scrollToSection(activeSection.value + 1)))
    }, [...(_cache[21] || (_cache[21] = [
      _createElementVNode("div", { class: "arrow-down" }, null, -1)
    ]))], 512), [
      [_vShow, activeSection.value > 0 && activeSection.value < 4]
    ])
  ]))
}
}

})